export const eventTypes = [
    { type: "somatic_breathing", label: "Somatic Breathing" },
    { type: "mindfulness", label: "Mindfulness" },
    { type: "ecstatic_dance", label: "Ecstatic Dance" },
    { type: "yoga", label: "Yoga" },
    { type: "meditation", label: "Meditation" },
    { type: "sound_healing", label: "Sound Healing" },
    { type: "workshop", label: "Workshop" },
    { type: "reiki", label: "Reiki" },
    { type: "retreat", label: "Retreat" },
    { type: "other", label: "Other" }
]

export const getByType = (eventType: string | null, items: any[]) => {
    if (eventType === null) return items;
    return items.filter(item => 
        // Check both the legacy event_type field and the new event_types array
        item.event_type === eventType || 
        item.event_types?.includes(eventType) ||
        item.provider_types?.includes(eventType)
    );
};

export const getEventTypeLabel = (eventType: string | null) => {
    const eventTypeLabel = eventTypes.find(et => et.type === eventType);
    return eventTypeLabel?.label || eventType;
};
